export const events = [];
export const isfNumber = 'B6K13521859753';
export const shipmentId = 'IBOGURA1800002';
export const disabled = false;
export const teamEvent = () => {
  return null;
};
export const accountType = 'team';
